/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 15:32
 * Desc: 业绩变脸
 */

import styles from './common.scss';
import React from 'react';
import { Spin } from 'antd';
import { formatNormalNumber } from '../../../../../utils/formatter';
import BBDLineBar from '../../../../common/echarts/BBDLineBar';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import { checkSearch } from '../../../common/commons';

export default class PerformanceFace extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.companyInfo = checkSearch();
        this.state = {
            loading: false,
            option: {}
        };
    }

    formatResponse = (data) => {
        data = data || {};
        let { list } = data;
        let category = [], lineData = [];
        list && list.forEach(d => {
            category.push(d.year);
            lineData.push(formatNormalNumber(d.netProfit));
        });

        return {
            option: {
                category,
                lineData
            }
        };
    };

    render() {
        const { loading, option } = this.state;
        const { reportYear } = this.companyInfo;

        return (
            <div >
                <div className="sub-title">业绩变脸情况（目标公司IPO年份为{reportYear}年）</div>
                <div className={styles.performanceChart}>
                    {
                        loading ?
                            <Spin /> :
                            <BBDLineBar option={option}/>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/PerformanceFace.jsx